module.exports = __webpack_public_path__ + "img/holy_bible.9583232e.jpg";